import { ReactNode } from 'react';
import { AdapterMoment, LocalizationProvider, ThemeProvider } from '@common-components';
import { AppPubSubProvider } from 'contexts/app-pub-sub/AppPubSub';
import { AblyPushingProvider } from './components/AblyPushingProvider';
import { Auth0ContextProvider } from './components/Auth0ContextProvider';
import { SubscriberIdProvider } from './components/SubscriberIdProvider';
import ToastProvider from './components/ToastProvider';
import { HotjarInitializedContext, ReactQueryProvider } from './contexts';
import { ErrorContextProvider } from './contexts/error';
import theme from './themes';

export const AppContextProviders = ({
  isHotjarInitialized,
  children,
}: {
  isHotjarInitialized: boolean;
  children: ReactNode;
}) => (
  <HotjarInitializedContext.Provider value={isHotjarInitialized}>
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <ToastProvider>
          <Auth0ContextProvider>
            <ErrorContextProvider>
              <ReactQueryProvider>
                <SubscriberIdProvider>
                  <AblyPushingProvider>
                    <AppPubSubProvider>{children}</AppPubSubProvider>
                  </AblyPushingProvider>
                </SubscriberIdProvider>
              </ReactQueryProvider>
            </ErrorContextProvider>
          </Auth0ContextProvider>
        </ToastProvider>
      </LocalizationProvider>
    </ThemeProvider>
  </HotjarInitializedContext.Provider>
);
